import React, {useContext} from 'react';
import axios from "axios";
import AppContext from "../../Context/AppContext.react";
import {getApiFromEnv} from "../../Utilities/utilities";

const useFetch = () => {
  const BASE_URL = getApiFromEnv();
  const APP_CONTEXT = useContext(AppContext);
  const AUTH_TOKEN = APP_CONTEXT.token
  const TENANT_ID = APP_CONTEXT.tenant.id

  const wait = ms => new Promise(r => setTimeout(r, ms));

  const retryOperation = (operation, delay, retries) => new Promise((resolve, reject) => {
    return operation()
      .then(resolve)
      .catch((reason) => {
        if (retries > 0) {
          return wait(delay)
            .then(retryOperation.bind(null, operation, delay, retries - 1))
            .then(resolve)
            .catch(reject);
        }
        return reject(reason);
      });
  });

  const fetchUrl = (url, ...params) => {

    const fetchTenants = (params) => {
      const errorMessage = 'Failed to fetch tenants.'
      return axios.get(`${BASE_URL}/tenants`, {
        headers: {Authorization: `Bearer ${AUTH_TOKEN}`}
      }).then(response => {
        return response.data.tenants
      }).catch(error => {
        console.error(error)
        console.log('error =>', errorMessage)
        return []
      })
    }

    const fetchCustomers = (page) => {
      console.log('TENANT ID =>', TENANT_ID);
      const errorMessage = 'Failed to fetch customers'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      let params = page[0];
      return axios.get(`${BASE_URL}/customers?`, {
        headers: {Authorization: authBearer}, params: params
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        console.log('Error =>', errorMessage);
      })
    }

    const searchCustomers = (queryString) => {
      const errorMessage = 'Failed to search customers'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customers?search=${queryString}`, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('Error =>', error);
        console.log('Error =>', errorMessage);
      })
    }

    const fetchCustomer = (customerID) => {
      const errorMessage = 'Failed to fetch customer'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customers/${customerID}`, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('Fetch customer failed =>', error);
        console.log('Error =>', errorMessage);
        return null;
      })
    }

    const updateCustomerMailing = (customer, preferences) => {
      const errorMessage = 'Failed to update customer mailing preference'
      const authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      let data = preferences;
      return axios.patch(`${BASE_URL}/customers/${customer.uuid}`, data, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('Customer mailing preference failed to update =>', error);
        console.log('Error =>', errorMessage);
        return null;
      })
    }

    const fetchCustomerAssets = (customerID) => {
      const errorMessage = 'Failed to fetch customer assets';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customer/${customerID}/accounts`, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        console.log('response =>', response);
        return response.data.accounts;
      }).catch((error) => {
        console.error('Fetch customer assets =>', error)
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const fetchCustomerBalance = (customerID) => {
      const errorMessage = 'Failed to fetch the customer balance';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customer/${customerID}/accounts/summary`, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        return response.data.total
      }).catch((error) => {
        console.error('Fetch customer balance =>', error)
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const fetchTransactions = (customerID, page=1, filters='') => {
      const errorMessage = 'Failed to fetch transactions';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customers/${customerID}/transactions`, {
        headers: {Authorization: authBearer},
        params: {page: page}
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('Fetch transactions error =>', error);
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const fetchTransaction = (customerID, transactionId) => {
      const errorMessage = 'Could not fetch the transaction'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customers/${customerID}/transactions/${transactionId}`, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        console.log('success on fetch transaction =>', response);
        return response.data;
      }).catch((error) => {
        console.error('Fetch transaction error =>', error);
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const editTransaction = (transaction) => {
      //TODO: not working
      // do we need it as a param?
      //    data: {
      //           'protected': true,
      //           'prices': prices,
      //           'memos': memoArray,
      //           'specific_type': ['INCOME', 'EXPENSE', 'GIFT-SENT', 'GIFT-RECEIVED'].includes(transactionType) ? transactionType.toLowerCase() : null
      //         }
      console.log('transaction =>', transaction);
      const errorMessage = 'Could not patch the transaction';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      let data = transaction;
      return axios.patch(`${BASE_URL}/customers/${transaction.user_id}/transactions/${transaction.id}`, data, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        console.log('patching transaction success =>', response);
        return response.data;
      }).catch((error) => {
        console.error('Patch transaction error =>', error);
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const fetchReconciledTransactions = () => {
      // api/reconciliation/reconciled

    }

    const fetchUnreconciledTransactions = () => {
      // api/reconciliation/unreconciled
      let mockData = [
        {id: '1', transactionID: 'feEdfefslk', counterParty: {name: 'Profluent', id: '132424'},  date: '3/22/2020', type: 'Loan', sent: {asset: 'BTC', quantity: 25, type: 'ASSET'}, received: { asset: 'USDC', quantity: 2000, type: 'FIAT'}, source: 'Torch'},
        {id: '2', transactionID: 'feEdslkje', counterParty: {name: 'Liquibit', id: '232423'},  date: '3/22/2020', type: 'Loan', sent: {asset: 'USDC', quantity: 500000, type: 'FIAT'}, received: { asset: '', quantity: '', type: ''}, source: 'Torch'},
        {id: '3', transactionID: 'fefselkje', counterParty: {name: 'Dunamis', id: '332422'},  date: '3/22/2020', type: 'Loan', sent: {asset: 'BTC', quantity: 25, type: 'ASSET'}, received: { asset: 'BTC', quantity: 1000, type: 'ASSET'}, source: 'Torch'},
        {id: '3', transactionID: 'fsfee', counterParty: {name: 'Cumberland', id: '432421'},  date: '3/22/2020', type: 'Loan', sent: {asset: 'BTC', quantity: 25, type: 'ASSET'}, received: { asset: 'USDC', quantity: 2000, type: 'FIAT'}, source: 'Torch'},
        {id: '4', transactionID: 'lmnoalekje', counterParty: {name: 'Liquibit', id: '532425'},  date: '3/22/2020', type: 'Loan', sent: {asset: 'BTC', quantity: 25, type: 'ASSET'}, received: { asset: 'USDC', quantity: 2000, type: 'FIAT'}, source:  'Torch'},
      ]
      const errorMessage = 'Could not fetch the transaction'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`

      return axios.get(`${BASE_URL}/reconciliation/unreconciled`, {
        headers: {Authorization: authBearer, 'Accept': 'application/pdf'},
      }).then((response) => {
        console.log('response =>', response.data.unreconciled);
        return response.data.unreconciled;
      }).catch((error) => {
        console.log('error =>', error);
        return [];
      })

      return mockData;
    }

    const fetchUnreconciledTransactionEntries = (params) => {
      console.log('params =>', params);
      let mockData = [
        {date: '10/29/2019', type: 'Transfer Out', sent: {asset: 'USDC', quantity: '10', type: 'FIAT'}, received: {asset: '', quantity: '', type: ''}, fee: {asset: 'ETH', quantity: 0.01190569, type: 'ASSET'}, source: 'Fireblocks', transactionID: '3545435', counterParty: {name: 'Coinfund', id: 'klj24234lkj'}},
        {date: '10/29/2019', type: 'Transfer Out', sent: {asset: 'USDC', quantity: '4999990', type: 'FIAT'}, received: {asset: '', quantity: '', type: ''}, fee: {asset: 'ETH', quantity: 0.01995469, type: 'ASSET'}, source: 'Fireblocks', transactionID: '23545435', counterParty: {name: 'Coinfund', id: '24234lkj'}},
        {date: '10/29/2019', type: 'Transfer Out', sent: {asset: 'USDC', quantity: '1500000', type: 'FIAT'}, received: {asset: '', quantity: '', type: ''}, fee: {asset: 'ETH', quantity: 0.01690569, type: 'ASSET'}, source: 'Fireblocks', transactionID: '13545435', counterParty: {name: 'Dunamis', id: 'eej24234lkj'}},
      ]
      const errorMessage = 'Could not fetch the transaction'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return mockData;
    }

    const fetchNextPage = (nextURL) => {
      //TODO: Get rid of this
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${nextURL}`, {
        headers: {Authorization: authBearer}
      }).then((response) => {
        return response.data;
      })
    }

    const download1099B = (customerID) => {
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/customers/${customerID}/forms/1099b`, {
        headers: {Authorization: authBearer, 'Accept': 'application/pdf'},
      }).then((response) => {
        const data = response.data
        if(data.status === 'SUCCESS' && data.signedUrl) {
          downloadUrl(data.signedUrl)
        }
        return data
      })
    }

    const downloadUrl = (url) => {
      const a = document.createElement("a")
      a.href = url
      a.click()
    }

    //TODO: Should this be here or someone else?
    const downloadFile = (response) => {
      const url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
      const a = document.createElement('a');
      a.href = url;
      const responseContentDisposition = response.headers['Content-Disposition']
      //TODO: Get the correct file information
      a.download = "1099B.pdf"//responseContentDisposition
      const clickHandler = () => {
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 150);
      };
      a.addEventListener('click', clickHandler, false);
      a.click();
      return null
    };

    const startCSVForm = (customerID) => {
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      //TODO: Look more into the types of asset issues
      //TODO: Look into having data in the form body
      return axios.post(`${BASE_URL}/customers/${customerID}/transactions/csv?fiat_asset_id=e2a4afac-92c6-11e9-a5ee-0a290192900c&accounting_method=fifo`, {}, {
        headers: {Authorization: authBearer},
      }).then((response) => {
        return response.data
      })
    }

    const checkCSVForm = (customerId, fileName) => {
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      //TODO: If it returns a 404 then do something...
      return axios.get(`${BASE_URL}/customers/${customerId}/transactions/csv?file_name=${fileName}`, {
        headers: {Authorization: authBearer},
      }).then((response) => {
        return response.data
      })
    }

    const downloadCSVForm = async (params) => {
      const customerId = params.customerId
      //Start csv
      const startResponse = await startCSVForm(customerId)
      const fileName = startResponse.csv
      //TODO: What is there is an error at this point?
      const result = await retryOperation(checkCSVForm.bind(null, customerId, fileName), 2500, 50)

      downloadUrl(result.url)
    }

    const fetchAuthUsers = () => {
      const errorMessage = 'Failed to fetch data for authorized users';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/users`, {
        headers: {Authorization: authBearer},
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('Error =>', error)
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const fetchAuthRoles = () => {
      const errorMessage = 'Failed to fetch auth roles';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/users/roles`, {
        headers: {Authorization: authBearer},
      }).then((response) => {
        return response.data.roles;
      }).catch((error) => {
        console.error('Error =>', error)
        console.log('Error =>', errorMessage);
        return [];
      })
    }

    const createAuthUser = (props) => {
      const errorMessage = 'Could not create authorized user'
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      let body = props[0]
      return axios.post(`${BASE_URL}/users`, body,
        {headers: {Authorization: authBearer}}).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('error ===>', error);
        console.log('Error =>', errorMessage);
      })
    }

    const editAuthUser = (props) => {
      const errorMessage = 'Could not patch the authorized user';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      let body = props[0]
      return axios.patch(`${BASE_URL}/users`, body,
        {headers: {Authorization: authBearer}}).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('error ===>', error);
        console.log('Error =>', errorMessage);
      })
    }

    const deleteAuthUser = ({userId}) => {
      const errorMessage = 'Failed to delete user';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      //TODO: Not tested
      return axios.delete(`${BASE_URL}/users/${userId}`, {
        headers: {Authorization: authBearer},
      }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error('Error =>', error);
        alert(errorMessage);
      })
    }

    const fetchReports = () => {
      const errorMessage = 'Failed to fetch reports';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.get(`${BASE_URL}/report/saved`, {
        headers: {Authorization: authBearer}
      }).then(response => {
        return response.data.reports
      }).catch(error => {
        console.error(error)
        console.log('Error =>', errorMessage);
        return []
      })
    }

    const runSavedReport = (params) => {
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      const errorMessage = 'Failed to run saved report'
      return axios.post(`${BASE_URL}/report/${params.reportId}`, {}, {
        headers: {Authorization: authBearer}
      }).then(response => {
        return response.data
      }).catch(error => {
        console.error(error)
        console.log('Error =>', errorMessage)
        return []
      })
    }

    const downloadCannedReport = (params) => {
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      const errorMessage = 'Failed to download saved report'
      return axios.post(`${BASE_URL}/report/${params.reportId}/download`, {}, {
        headers: {Authorization: authBearer}
      }).then(response => {
        return response.data
      }).catch(error => {
        console.error(error)
        console.log('Error =>', errorMessage)
        return []
      })
    }

    const runCustomReport = (params) => {
      const errorMessage = 'Failed to run custom report';
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      return axios.post(`${BASE_URL}/report/custom`, {
        query: params.query
      }, {
        headers: {Authorization: authBearer}
      }).then(response => {
        return response.data
      }).catch(error => {
        console.error(error)
        console.log('Error =>', errorMessage);
        return []
      })
    }

    const download8949 = (params) => {
      let authBearer = TENANT_ID !== null ? `Bearer ${AUTH_TOKEN}:${TENANT_ID}` : `Bearer ${AUTH_TOKEN}`
      let customerID = params.customerID
      let data = params.body;
      return axios.post(`${BASE_URL}/customers/${customerID}/forms/8949`, data, {
        headers: {Authorization: authBearer}
      }).then(response => {
        return response.data
      }).catch(error => {
        console.log('Error downloading =>', error)
        return []
      })
    }
    
    switch (url) {
      case 'fetchTenants':
        return fetchTenants(params)
      case 'fetchCustomers':
        return fetchCustomers(params);
      case 'fetchCustomer':
        return fetchCustomer(params);
      case 'updateCustomerMailing':
        return updateCustomerMailing(...params);
      case 'searchCustomers':
        return searchCustomers(params)
      case 'fetchCustomerAssets':
        return fetchCustomerAssets(params)
      case 'fetchCustomerBalance':
        return fetchCustomerBalance(params)
      case 'fetchTransactions':
        return fetchTransactions(...params);
      case 'fetchTransaction':
        return fetchTransaction(...params)
      case 'editTransaction':
        return editTransaction(...params);
      case 'fetchUnreconciledTransactions':
        return fetchUnreconciledTransactions();
      case 'fetchUnreconciledTransactionEntries':
        return fetchUnreconciledTransactionEntries(...params);
      case 'fetchNextPage':
        return fetchNextPage(params)
      case 'fetchAuthUsers':
        return fetchAuthUsers(params);
      case 'createAuthUser':
        return createAuthUser(params);
      case 'editAuthUser':
        return editAuthUser(params);
      case 'deleteAuthUser':
        return deleteAuthUser(params);
      case 'fetchAuthRoles':
        return fetchAuthRoles(params);
      case 'download1099B':
        return download1099B(params)
      case 'startCSVForm':
        return startCSVForm(params)
      case 'checkCSVForm':
        return checkCSVForm(params)
      case 'downloadCSVForm':
        return downloadCSVForm.apply(null, params)
      case 'fetchReports':
        return fetchReports(params)
      case 'runSavedReport':
        return runSavedReport(...params)
      case 'downloadCannedReport':
        return downloadCannedReport(...params)
      case 'runCustomReport':
        return runCustomReport(...params)
      case 'download8949':
        return download8949(...params)
      default:
        return console.log('no endpoint found')
    }
  }

  return [fetchUrl];
}




export default useFetch;
